import {
  CheckBox,
  DatePicker,
  DateTimePicker,
  DropdownField,
  ItemsListField,
  Label,
  Button,
  MeasureField,
  NumberField,
  RadioButton,
  TextField,
  TimePicker,
  TokenField,
} from '@icure/form/components/icure-form/fields'
import { IcureButtonGroup } from '@icure/form/components/icure-button-group'
import { IcureDatePickerField } from '@icure/form/components/icure-date-picker'
import { IcureDropdownField } from '@icure/form/components/icure-dropdown-field'
import { IcureForm } from '@icure/form/components/icure-form'
import { IcureLabel } from '@icure/form/components/icure-label'
import { IcureTextField, MetadataButtonBarWrapper } from '@icure/form/components/icure-text-field'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ehrLiteCss from '!!css-loader?{"sourceMap":false,"exportType":"string"}!less-loader!./preventi.less'

import { MetadataButtonBar } from '@icure/form/components/common/metadata-buttons-bar'
import { IcureButton } from '@icure/form/components/icure-button'
import { FormSelectionButton } from '@icure/form/components/icure-form/renderer/form/form-selection-button'
import { unsafeCSS } from 'lit'

class EhrLiteIcureButtonGroup extends IcureButtonGroup {
  static get styles() {
    return [...IcureButtonGroup.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteIcureDatePickerField extends IcureDatePickerField {
  static get styles() {
    return [...IcureDatePickerField.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteIcureDropdownField extends IcureDropdownField {
  static get styles() {
    return [...IcureDropdownField.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteIcureForm extends IcureForm {
  static get styles() {
    return [...IcureForm.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteIcureLabel extends IcureLabel {
  static get styles() {
    return [...IcureLabel.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteIcureButton extends IcureButton {
  static get styles() {
    return [...IcureButton.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteIcureTextField extends IcureTextField {
  static get styles() {
    return [...IcureTextField.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteLabel extends Label {
  static get styles() {
    return [...Label.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteMetadataButtonBar extends MetadataButtonBar {
  static get styles() {
    return [...MetadataButtonBar.styles, unsafeCSS(ehrLiteCss)]
  }
}
class EhrLiteButton extends Button {
  static get styles() {
    return [...Button.styles, unsafeCSS(ehrLiteCss)]
  }
}

customElements.define('icure-metadata-buttons-bar', EhrLiteMetadataButtonBar)
customElements.define('icure-metadata-buttons-bar-wrapper', MetadataButtonBarWrapper)

customElements.define('icure-form-checkbox', CheckBox)
customElements.define('icure-form-date-picker', DatePicker)
customElements.define('icure-form-date-time-picker', DateTimePicker)
customElements.define('icure-form-dropdown-field', DropdownField)
customElements.define('icure-button-group', EhrLiteIcureButtonGroup)
customElements.define('icure-date-picker-field', EhrLiteIcureDatePickerField)
customElements.define('icure-dropdown-field', EhrLiteIcureDropdownField)
customElements.define('icure-form', EhrLiteIcureForm)
customElements.define('icure-label', EhrLiteIcureLabel)
customElements.define('icure-button', EhrLiteIcureButton)
customElements.define('icure-text-field', EhrLiteIcureTextField)
customElements.define('icure-form-items-list-field', ItemsListField)
customElements.define('icure-form-label', EhrLiteLabel)
customElements.define('icure-form-button', EhrLiteButton)
customElements.define('icure-form-measure-field', MeasureField)
customElements.define('icure-form-number-field', NumberField)
customElements.define('icure-form-radio-button', RadioButton)
customElements.define('icure-form-text-field', TextField)
customElements.define('icure-form-time-picker', TimePicker)
customElements.define('icure-form-token-field', TokenField)
customElements.define('form-selection-button', FormSelectionButton)
